import React from 'react';

export default function LightsIcon(){
  return (
    <svg
      width="14"
      height="22"
      viewBox="0 0 14 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5881 13.0142C11.7673 13.0142 11.0786 12.4706 10.8433 11.7272C10.5243 11.994 10.1191 12.1615 9.67128 12.1615C8.94527 12.1615 8.32216 11.7343 8.02409 11.1215C7.89032 11.2425 7.73667 11.3468 7.5635 11.4284C7.30376 11.5505 7.02485 11.6101 6.74914 11.6101C6.46988 11.6101 6.19558 11.543 5.94435 11.4235C5.66296 11.8479 5.25418 12.1874 4.75101 12.3425C5.46886 13.0089 5.91242 14.0976 5.91242 15.3676C5.91242 15.5773 5.74244 15.7469 5.53309 15.7469C5.32373 15.7469 5.15376 15.5769 5.15376 15.3676C5.15376 13.8311 4.40965 12.6303 3.34157 12.4351H2.46475C2.25503 12.4351 2.08542 12.2652 2.08542 12.0558C2.08542 11.8464 2.25539 11.6768 2.46475 11.6768H4.14671C5.10053 11.6768 5.60867 10.7365 5.60867 10.0577C5.60867 9.82631 5.55083 9.62724 5.44579 9.49736C5.33828 9.36536 5.18179 9.30078 4.96534 9.30078H0.665688C0.328941 9.30078 0 9.39233 0 10.4881V14.4914C0 16.9903 0.74056 18.2908 2.93492 19.6452C3.04669 19.714 3.11518 19.8365 3.11518 19.9678V21.622C3.11518 21.8314 3.28479 22.0014 3.49451 22.0014H10.3859C10.5956 22.0014 10.7653 21.8314 10.7653 21.622V19.9678C10.7653 19.8524 10.8178 19.7431 10.9083 19.6711C12.8159 18.151 13.6661 16.5534 13.6661 14.4911V12.6569C13.3627 12.879 12.9923 13.0142 12.5881 13.0142Z"
        fill="#717BBC"
      />
      <path
        d="M4.91871 1.07837C4.91871 0.483653 4.43505 0 3.84033 0C3.24562 0 2.76196 0.483653 2.76196 1.07837V8.54075H4.92651L4.91871 1.07837Z"
        fill="#717BBC"
      />
      <path
        d="M9.67128 11.4013C10.266 11.4013 10.7497 10.9176 10.7497 10.3229V7.80067C10.7497 7.20631 10.266 6.72266 9.67128 6.72266C9.07692 6.72266 8.59326 7.20631 8.59326 7.80067V10.3229C8.59326 10.9176 9.07692 11.4013 9.67128 11.4013Z"
        fill="#717BBC"
      />
      <path
        d="M5.67993 6.80247C5.68064 6.81134 5.68525 6.81879 5.68525 6.82802V8.7236C5.83926 8.81195 5.95423 8.92018 6.03513 9.02025C6.25265 9.28851 6.36762 9.64761 6.36762 10.0582C6.36762 10.2863 6.33143 10.517 6.26472 10.7405C6.56349 10.885 6.92366 10.891 7.24125 10.743C7.41228 10.6625 7.79445 10.4201 7.83455 9.89103V6.82837C7.83455 6.23365 7.35089 5.75 6.75653 5.75C6.17033 5.74965 5.69413 6.21981 5.67993 6.80247Z"
        fill="#717BBC"
      />
      <path
        d="M12.5867 12.2542C13.1828 12.2542 13.6665 11.7701 13.6665 11.1758V8.98072C13.6665 8.386 13.1821 7.90234 12.5867 7.90234C11.992 7.90234 11.5083 8.386 11.5083 8.98072V11.1761C11.5083 11.7701 11.992 12.2542 12.5867 12.2542Z"
        fill="#717BBC"
      />
    </svg>
  );
}